import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ScreenSaverView from '../views/ScreenSaverView.vue'
import IFrameView from '../views/IFrameView.vue'

const routes = [
  {
    path: '/',
    name: 'screensaver',
    component: ScreenSaverView
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    props: {
      buttons: [
        { text: 'Internet',  color: '#1fb8d1', route : { name: 'site',  query : { url : 'https://www.netplus.ch/fr/offres-combo/#/startup'}} },
        { text: 'Mobile', color: '#ffd902', textColor:"#000", route : { name: 'mobile-home'} },
        { text: 'TV', color: '#e72061', route : { name: 'tv-home'} },
        { text: 'Produits', route : { name: 'products-home'} },
        { text: 'Académie', route : { name: 'site',  query : { url : 'https://www.netplus.ch/fr/academie/'}} },
        { text: 'Concours', route : { name: 'site',  query : { url : 'https://netplus.ch/borne'}} }
      ]
    }
  },
  {
    path: '/mobile-home',
    name: 'mobile-home',
    component: HomeView,
    props: {
      buttons: [
        { text: 'Nos abos', color: '#ffd902', textColor:"#000", route : { name: 'site',  query : { url : 'https://www.netplus.ch/fr/offres-mobiles-irresistibles/'}} },
        { text: 'Offre pour les -30 ans', color: '#ffd902', textColor:"#000", route : { name: 'site',  query : { url : 'https://www.netplus.ch/fr/offres-mobiles-irresistibles/offres-mobiles-jeunes-3956'}} },
        { text: 'eSIM', color: '#ffd902', textColor:"#000", route : { name: 'site',  query : { url : 'https://www.netplus.ch/fr/offres-mobiles-irresistibles/esim-2322'}} },
        { text: 'SIM secondaire', color: '#ffd902', textColor:"#000", route : { name: 'site',  query : { url : 'https://www.netplus.ch/fr/offres-mobiles-irresistibles/sim-secondaire-3065'}} },
        { text: 'MobiSurfer', color: '#ffd902', textColor:"#000",  route : { name: 'site',  query : { url : 'https://www.netplus.ch/fr/offres-mobiles-irresistibles?scroll_to=mobile_data2'}}},
      ]
    }
  },
  {
    path: '/tv-home',
    name: 'tv-home',
    component: HomeView,
    props: {
      buttons: [
        { text: 'Box TV', color: '#e72061', route : { name: 'site',  query : { url : 'https://www.netplus.ch/fr/television/android-tv-v2-3921'}} },
        { text: 'Guide des chaines', color: '#e72061', route : { name: 'site',  query : { url : 'https://www.netplus.ch/fr/television/chaines-tv-1016'}}},
        { text: 'Bouquets', color: '#e72061',  route : { name: 'site',  query : { url : 'https://www.netplus.ch/fr/television/bouquets-tv-1447'}}},
        { text: 'App TV Mobile', color: '#e72061', route : { name: 'site',  query : { url : 'https://www.netplus.ch/fr/television/application-tv-mobile-547'}} },
        { text: 'FAST Channels', color: '#e72061', route : { name: 'site',  query : { url : 'https://www.netplus.ch/fr/television/fast-channels/'}} },
      ]
    }
  },
  {
    path: '/products-home',
    name: 'products-home',
    component: HomeView,
    props: {
      buttons: [
        { text: 'MobiZen', route : { name: 'site',  query : { url : 'https://www.netplus.ch/fr/protegez-vos-proches/'}} },
        { text: 'Plume', route : { name: 'site',   query : { url : 'https://www.netplus.ch/fr/offres-combo/wi-fi-3485'}}},
        { text: 'MobiSurfer',  route : { name: 'site',  query : { url : 'https://www.netplus.ch/fr/offres-mobiles-irresistibles?scroll_to=mobile_data2'}}},
        ]
    }
  },
  {
    path: '/site',
    name: 'site',
    component: IFrameView,
    props: route => ({ iframeUrl: route.query.url })
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router;